import { Loader2, WifiOff } from 'lucide-react'

import Button from '@/components/ui/Button'

/**
 * Serwer nie odpowiedział na pytanie o sesję. To NIE jest wylogowanie —
 * odesłanie na /login kazało logować się od nowa przy wciąż ważnej sesji,
 * a nowe logowanie pracownika kasuje jego poprzednią sesję na serwerze.
 */
export default function ServerUnreachable({
  onRetry,
  retrying,
}: {
  onRetry: () => void
  retrying: boolean
}) {
  return (
    <main className="min-h-[100svh] flex items-center justify-center px-6 py-12 bg-bg-canvas">
      <div className="w-full max-w-[420px] rounded-card border border-border-subtle bg-bg-elevated p-8 text-center">
        <WifiOff className="mx-auto mb-3 h-6 w-6 text-warning" aria-hidden />
        <h1 className="text-lg font-semibold">Brak połączenia z serwerem</h1>
        <p className="mt-2 text-sm text-text-muted">
          Nie udało się sprawdzić logowania. Sprawdź Wi-Fi lub dane komórkowe
          i spróbuj ponownie.
        </p>
        {/* Bez `loading`: wyłączony w trakcie próby przycisk gubi fokus
            klawiatury, a po nieudanej próbie trzeba go nacisnąć jeszcze raz.
            Wariant `secondary` — tusz text-primary na karcie, bez pary
            „wypełnienie + kolor tła strony jako tekst". */}
        <Button
          type="button"
          variant="secondary"
          aria-busy={retrying}
          onClick={() => {
            if (!retrying) onRetry()
          }}
          className="mt-6 w-full min-h-[44px]"
        >
          {retrying && <Loader2 className="h-4 w-4 animate-spin" aria-hidden />}
          Spróbuj ponownie
        </Button>
      </div>
    </main>
  )
}
